import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import CreateLegalEntityPage from 'modules/settings/components/Payroll/LegalEntities/NewLegalEntityPage'

const CreatePage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onSuccess = (id: number) => {
    navigate(navigation.settings.legalEntitiesId.fullPath({ id }))
  }

  const onClose = () => {
    navigate(navigation.settings.details.fullPath())
  }

  return <CreateLegalEntityPage onSuccess={onSuccess} onClose={onClose} />
}

export default CreatePage
